import { render, staticRenderFns } from "./ProfessionalCommittee.vue?vue&type=template&id=4280f51e"
import script from "./ProfessionalCommittee.vue?vue&type=script&lang=js"
export * from "./ProfessionalCommittee.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalCommittee.vue?vue&type=style&index=0&id=4280f51e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports